import CodeEditor from '@uiw/react-textarea-code-editor';
import { useState } from 'react';
import Icon from './Icon';

const Program = ({animations,setAnimations}) => {


  

    const [demoCode,setDemoCode] = useState('"#demoElement":'+JSON.stringify(animations.data['#demoElement'],null, "\t"))
    
    const [ok,setOk] = useState(true)
    const refresh = code => {
        const originalCode = code;
        code = '{'+code+'}'
        let codeChecks = false;
        setDemoCode(originalCode)
        try{
            JSON.parse(code)
            codeChecks = true
        } catch(err){
            codeChecks = false;
        }
        if (codeChecks){
            const newData = {...animations}
            newData.data['#demoElement'] = JSON.parse(code)['#demoElement']
            setAnimations(newData)
        }
        setOk(codeChecks)
    }

  
  

    const indicator = () => {
        let cl = ok ? 'bg-teal-300 ' : 'bg-red-400 '
        return <div className={cl+' animate-pulse absolute bottom-4 right-4 w-4 h-4 rounded-full'}></div>
    }

    return <section className='py-20 dark bg-slate-900'>
        <div className='container mx-auto px-5 lg:px-10'>
            <div className='max-w-prose'>
                <Icon name='api' inner='fill-indigo-400' outer='bg-indigo-400 bg-opacity-20' />
                <h2>Fully programmable</h2>
                <p className="sub">Gain extra control on your animations with Animator's <code>data</code> object. Manually edit it's content or program it to perform complex operations.</p>
            </div>
          
        </div>
        <div className='container mx-auto flex flex-col lg:flex-row bg-slate-800 border border-slate-700 overflow-hidden rounded-3xl '>
            <div className='flex-1 flex items-center justify-center lg:min-h-0 min-h-[600px]'>
                <div id='demoElement' className='w-20 h-20 rounded bg-teal-300'></div>
            </div>
            <div className='h-[500px] overflow-hidden border-slate-700 border flex-1 bg-slate-900 rounded-2xl m-4 relative'>
                {indicator()}
                <CodeEditor
                    value={demoCode}
                    language="json"
                    placeholder="Medievil Rave MK2"
                    onChange={(evn) => refresh(evn.target.value)}
                    padding={15}
                    style={{
                        fontSize: 18,
                        fontWeight:'bold',
                        backgroundColor: "transparent",
                        color:'white',
                        fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                }} />
            </div>
        </div>
    </section>
}

export default Program